import styled from 'styled-components'

export const CreateReservationContainer = styled.div`
  width: 100%;

  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  gap: 30px;
`

export const Loading = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 150px;
`

export const ButtonWrapper = styled.div`
  width: 100%;

  p {
    color: #898989;
    max-width: 200px;
    margin: 0 auto;
  }

  button {
    width: 100%;
    margin-top: 15px;
  }
`

export const ProfessionalRestrictionsFeedbackContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  background: #f5f5f5;
  border-radius: 5px;
  padding: 20px;

  ul {
    margin-top: 5px;
    margin-bottom: 15px;

    li {
      font-weight: bold;
    }
  }

  span {
    color: #fd4949;
    font-weight: bold;
  }
`